import { VStack } from "@chakra-ui/react"
import PropTypes from "prop-types"
import { useState } from "react"
import styled from "styled-components"
import useCohortPermissions from "../../../cohort/useCohortPermissions"
import DiscussionForm from "../../../discussion/form/DiscussionForm"
import Discussions from "../../../discussion/list"
import { useCommunityContext } from "../../Community"
import useCommunityAreas from "../useCommunityAreas"
import CommunityDiscussionNav from "./CommunityDiscussionNav"

const Form = styled.div`
  padding-top: 1em;
  padding-bottom: 2em;
`

const CommunityDiscussion = (props) => {
  const { onSelectDiscussion, onStartDiscussion, inverted } = props
  const { resourceId, cohortId } = useCommunityContext()
  const { selectedArea } = useCommunityAreas()
  const [hideNav, setHideNav] = useState(false)
  const cohortPerms = useCohortPermissions({ cohortId })
  const context = {
    resource_id: resourceId,
    cohort_id: cohortId
  }

  return (
    <Discussions.Container
      context={context}
      onSelectDiscussion={onSelectDiscussion}
      // onStartDiscussion={onStartDiscussion}
      filterBySelectedDiscussionTag
    >
      <Form>
        {
          // observers can't post new discussions
          cohortPerms.hasLearnerLevelAccess && (
            <DiscussionForm
              onToggleExpanded={(expanded) => setHideNav(expanded)}
            />
          )
        }
      </Form>
      <VStack spacing={4}>
        {!hideNav && <CommunityDiscussionNav inverted={inverted} />}
        <Discussions.List
          onSelectDiscussion={onSelectDiscussion}
          onStartDiscussion={onStartDiscussion}
          inverted={inverted}
        >
          {selectedArea.renderBlankSlate}
        </Discussions.List>
      </VStack>
    </Discussions.Container>
  )
}

CommunityDiscussion.displayName = "CommunityDiscussion"

CommunityDiscussion.propTypes = {
  inverted: PropTypes.bool,
  onSelectDiscussion: PropTypes.func,
  onStartDiscussion: PropTypes.func
}

// CommunityDiscussion.defaultProps = {
//   onSelectDiscussion: () => {},
//   onStartDiscussion: () => {}
// }

export default CommunityDiscussion
